import { render, staticRenderFns } from "./DataPrivacy.vue?vue&type=template&id=a2ea9fc8&scoped=true&"
import script from "./DataPrivacy.vue?vue&type=script&lang=js&"
export * from "./DataPrivacy.vue?vue&type=script&lang=js&"
import style0 from "./DataPrivacy.vue?vue&type=style&index=0&id=a2ea9fc8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2ea9fc8",
  null
  
)

export default component.exports